import DataTableEditable from './DataTableEditable';

export default DataTableEditable;
